import {
  Category as CategoriesIcon,
  Dashboard as DashboardIcon,
  Inventory as ProductsIcon,
  SubdirectoryArrowRight as SubcategoriesIcon,
  Receipt as TvasIcon,
  LocalOffer as BrandsIcon,
  FamilyRestroom as FamiliesIcon,
  Discount as PromotionsIcon,
  EmojiEvents as GradesIcon,
  ShoppingCart as OrdersIcon,
  People as UsersIcon,
  Article as NewsIcon,
  Stars as LoyaltyIcon,
  Payment as PaymentIcon,
  CardMembership as AffiliateIcon,
  BarChart as StatsIcon,
  TrendingUp as PriceIcon,
  LocalShipping as ShippingIcon,
  AttachMoney as RatesIcon,
  Inventory2 as KitsIcon,
  Speed as XpIcon,
  ExpandLess,
  ExpandMore,
  Storefront as CatalogIcon,
  Campaign as MarketingIcon,
  Settings as SettingsIcon,
  Notifications as NotificationsIcon,
  Domain as SupplierIcon,
  Warehouse as StockIcon,
} from '@mui/icons-material';
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
} from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const menuStructure = [
  {
    type: 'single',
    text: 'Tableau de bord',
    icon: <DashboardIcon />,
    path: '/',
  },
  {
    type: 'group',
    text: 'Analyse',
    icon: <StatsIcon />,
    items: [
      { text: 'Statistiques', icon: <StatsIcon />, path: '/statistics' },
      { text: 'Prix Concurrents', icon: <PriceIcon />, path: '/price-comparison' },
    ],
  },
  {
    type: 'group',
    text: 'Catalogue',
    icon: <CatalogIcon />,
    items: [
      { text: 'Produits', icon: <ProductsIcon />, path: '/products' },
      { text: 'Stock unitaire', icon: <StockIcon />, path: '/stock' },
      { text: 'Kits Personnalisables', icon: <KitsIcon />, path: '/kits' },
      { text: 'Catégories', icon: <CategoriesIcon />, path: '/categories' },
      { text: 'Sous-catégories', icon: <SubcategoriesIcon />, path: '/subcategories' },
      { text: 'Marques', icon: <BrandsIcon />, path: '/brands' },
      { text: 'Familles', icon: <FamiliesIcon />, path: '/families' },
      { text: 'Fournisseurs', icon: <SupplierIcon />, path: '/suppliers' },
      { text: 'Commandes Fournisseur', icon: <SupplierIcon />, path: '/supplier-orders' },
    ],
  },
  {
    type: 'single',
    text: 'Commandes',
    icon: <OrdersIcon />,
    path: '/orders',
  },
  {
    type: 'group',
    text: 'Marketing',
    icon: <MarketingIcon />,
    items: [
      { text: 'Promotions', icon: <PromotionsIcon />, path: '/promotions' },
      { text: 'Actualités', icon: <NewsIcon />, path: '/news' },
      { text: 'Notifications Push', icon: <NotificationsIcon />, path: '/notifications' },
    ],
  },
  {
    type: 'group',
    text: 'Fidélité',
    icon: <LoyaltyIcon />,
    items: [
      { text: 'Grades & Niveaux', icon: <GradesIcon />, path: '/grades' },
      { text: 'Points de Fidélité', icon: <LoyaltyIcon />, path: '/loyalty' },
      { text: 'Configurations XP', icon: <XpIcon />, path: '/xp-configurations' },
    ],
  },
  {
    type: 'group',
    text: 'Affiliés',
    icon: <AffiliateIcon />,
    items: [
      { text: 'Affiliés', icon: <AffiliateIcon />, path: '/affiliates' },
      { text: 'Demandes d\'affiliation', icon: <AffiliateIcon />, path: '/affiliate-requests' },
      { text: 'Campagnes', icon: <AffiliateIcon />, path: '/affiliate-campaigns' },
      { text: 'Demandes produits', icon: <AffiliateIcon />, path: '/affiliate-product-requests' },
      { text: 'Avis', icon: <AffiliateIcon />, path: '/affiliate-reviews' },
    ],
  },
  {
    type: 'group',
    text: 'Configuration',
    icon: <SettingsIcon />,
    items: [
      { text: 'Modes de Paiement', icon: <PaymentIcon />, path: '/payment-methods' },
      { text: 'Modes de Livraison', icon: <ShippingIcon />, path: '/shipping-methods' },
      { text: 'Tarifs de Livraison', icon: <RatesIcon />, path: '/shipping-rates' },
      { text: 'TVA', icon: <TvasIcon />, path: '/tvas' },
    ],
  },
  {
    type: 'single',
    text: 'Utilisateurs',
    icon: <UsersIcon />,
    path: '/users',
  },
];

// Helper Component for Single Item
const SidebarMenuItem = ({ item, isSelected, onClick }) => (
  <ListItem disablePadding>
    <ListItemButton
      onClick={onClick}
      selected={isSelected}
      sx={{
        mx: 1,
        borderRadius: 1,
        '&.Mui-selected': {
          backgroundColor: 'primary.main',
          color: 'white',
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
          '& .MuiListItemIcon-root': {
            color: 'white',
          },
        },
        '&:hover': {
          backgroundColor: 'rgba(144, 202, 249, 0.08)',
        },
      }}
    >
      <ListItemIcon
        sx={{
          color: isSelected ? 'white' : 'text.secondary',
          minWidth: 40,
        }}
      >
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={item.text}
        sx={{
          '& .MuiTypography-root': {
            fontWeight: isSelected ? 600 : 400,
            fontSize: '0.9rem',
          },
        }}
      />
    </ListItemButton>
  </ListItem>
);

// Helper Component for Group Item
const SidebarGroupItem = ({ group, isOpen, onToggle, location, navigate }) => {
  const hasActiveChild = group.items.some(item => location.pathname === item.path);

  return (
    <Box>
      <ListItem disablePadding>
        <ListItemButton
          onClick={onToggle}
          sx={{
            mx: 1,
            borderRadius: 1,
            backgroundColor: hasActiveChild ? 'rgba(144, 202, 249, 0.08)' : 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(144, 202, 249, 0.12)',
            },
          }}
        >
          <ListItemIcon
            sx={{
              color: hasActiveChild ? 'primary.main' : 'text.secondary',
              minWidth: 40,
            }}
          >
            {group.icon}
          </ListItemIcon>
          <ListItemText
            primary={group.text}
            sx={{
              '& .MuiTypography-root': {
                fontWeight: hasActiveChild ? 600 : 500,
                fontSize: '0.95rem',
              },
            }}
          />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ pl: 2 }}>
          {group.items.map(item => (
            <SidebarMenuItem
              key={item.text}
              item={item}
              isSelected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
            />
          ))}
        </List>
      </Collapse>
    </Box>
  );
};

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openGroups, setOpenGroups] = useState({});

  const handleGroupClick = (groupText) => {
    setOpenGroups(prev => ({
      ...prev,
      [groupText]: !prev[groupText]
    }));
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: '#1e1e1e',
          borderRight: '1px solid #333333',
        },
      }}
    >
      <Box sx={{
        overflow: 'auto',
        mt: 8,
        '&::-webkit-scrollbar': { width: '6px' },
        '&::-webkit-scrollbar-track': { backgroundColor: '#2a2a2a', borderRadius: '3px' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: '#555555', borderRadius: '3px', '&:hover': { backgroundColor: '#666666' } },
        scrollbarWidth: 'thin',
        scrollbarColor: '#555555 #2a2a2a',
      }}>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main' }}>
            Administration
          </Typography>
        </Box>

        <Divider />

        <List>
          {menuStructure.map((item) => {
            if (item.type === 'single') {
              return (
                <SidebarMenuItem
                  key={item.text}
                  item={item}
                  isSelected={location.pathname === item.path}
                  onClick={() => navigate(item.path)}
                />
              );
            } else if (item.type === 'group') {
              return (
                <SidebarGroupItem
                  key={item.text}
                  group={item}
                  isOpen={!!openGroups[item.text]}
                  onToggle={() => handleGroupClick(item.text)}
                  location={location}
                  navigate={navigate}
                />
              );
            }
            return null;
          })}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
